module.exports = __webpack_public_path__ + "assets/img/18_1819_big.cf8ea752.jpg";